import { render, staticRenderFns } from "./LoginIndex.vue?vue&type=template&id=203d51f6&scoped=true"
import script from "./LoginIndex.vue?vue&type=script&lang=js"
export * from "./LoginIndex.vue?vue&type=script&lang=js"
import style0 from "./LoginIndex.vue?vue&type=style&index=0&id=203d51f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203d51f6",
  null
  
)

export default component.exports